import { render } from "./OrderQuickAddModalWrapper.vue?vue&type=template&id=3ce2fa1d"
import script from "./OrderQuickAddModalWrapper.vue?vue&type=script&lang=js"
export * from "./OrderQuickAddModalWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__